export const willLoseUnsavedWork = ({
  unsavedWork,
  newPath,
  oldPath,
  isModalClose
}) => {
  if (isModalClose) return unsavedWork.some(w => w.modal)
  else if (newPath) return (
    newPath !== oldPath &&
    unsavedWork.some(w =>
      !w.safePath ||
      !newPath.startsWith(w.safePath)
    )
  )
  else return unsavedWork.length > 0
}

export const getUnsavedWorkMessage = (isModal) =>
  `You have unsaved work. Are you sure you want to ${
    isModal
      ? 'close this modal'
      : 'leave this page'
  } without saving it?`
